import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Box, Modal, ModalContext, Text, toast } from 'dash-ui';

import {
  GetOrganizationUsersDocument,
  useSendRegistrationLinkToDeveloperMutation,
} from 'gql/generated.graphql';
import { OrganizationUsersModalsEnum } from 'pages/organizations/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/constants/constants';

function SendRegistrationLinkToUserModal() {
  const {
    isOpenCurrent,
    toggleModal,
    setPayload,
    payload: accountId,
  } = useContext(ModalContext);
  const isOpen =
    isOpenCurrent[OrganizationUsersModalsEnum.SEND_REGISTRATION_LINK_TO_USER] ||
    false;
  const { t: tCommon } = useTranslation('common');
  const { t } = useTranslation('pages', { keyPrefix: 'organizationUsers' });
  const theme = useTheme();

  const [sendRegistrationLinkToUser, { loading }] =
    useSendRegistrationLinkToDeveloperMutation({
      onError: (error) => toast.error(error.toString()),
      onCompleted: () => toast.success(tCommon('alerts.invitationHasBeenSent')),
    });

  const onSubmitModal = () => {
    sendRegistrationLinkToUser({
      refetchQueries: [GetOrganizationUsersDocument],
      onCompleted: onCloseModal,
      variables: { accountId },
    });
  };

  const onCloseModal = () => {
    toggleModal(
      false,
      OrganizationUsersModalsEnum.SEND_REGISTRATION_LINK_TO_USER
    );
    setPayload(undefined);
  };

  return (
    <Modal
      title={t('inviteUserModalTitle') || ''}
      isOpen={isOpen}
      submitButton={{
        title: t('inviteUserModalSubmitButton'),
        onClick: onSubmitModal,
        isLoading: loading,
      }}
      cancelButton={{
        title: t('inviteUserModalCancelButton'),
        onClick: onCloseModal,
      }}
    >
      <Box py={3}>
        <Text color={theme.colors.n80}>{t('inviteUserModalSubtitle')}</Text>
      </Box>
    </Modal>
  );
}

export default SendRegistrationLinkToUserModal;
